import React, { useContext, useEffect } from 'react';
import InlineInputControlRow from '../../ui/layout/InlineInputControlRow';
import SecondaryButton from "../../ui/SecondaryButton";
import TextBox from '../../ui/TextBox';
import Float from '../../ui/Float';
import { WItemEDI } from '../../fms.core/WItemEDI';
import { useTypedFastStorage } from '../../hooks/useFastStorage';
import ApplicationContext from '../../ApplicationContext';
import { SQLField, SQLInfo, SQLType } from '../../framework.core/data/SQLInfo';
import _ from 'lodash';
import useGlobalOkDialog from '../../hooks/useGlobalOkDialog';
import { readExcel } from '../../excel';
import GreenButtonInputExcel from '../../ui/GreenButtonInputExcel';
import { SQLIndex } from '../../fms.core/constants';
import { ApiResult, InsertResultsWithData } from '../../framework.core/data/ApiResult';
import { JobNames } from '../../framework.core/JobNames';
import EdiWebCenterDropDown from '../../uiControls/EdiWebCenterDropDown';
import JobListViewContext from '../common/JobListViewContext';
interface ItemUploadParams {
  onPopupClose: () => void,
  isPhysicalInven: boolean
};

interface ItemUploadLoadedParams {
  onPopupClose: (doRefresh: boolean) => void,
  onSave: () => void,
  isPhysicalInven: boolean,
  wItemEDI: WItemEDI,
  onChange: (x: Partial<WItemEDI>) => void,
};

function ItemUploadImpl(params: ItemUploadParams) {
  const modelStorage = 'item-upload';
  const [itemStorage, setItemStorage, removeItemStorage, ] = useTypedFastStorage<WItemEDI>(modelStorage, null);
  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);

  const [showGlobalOkDialog] = useGlobalOkDialog();

  const userID = appContext.user ? appContext.user.id ?? '' : '';
  const newItemModel = new WItemEDI();

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function initialize() {
    const newModel = _.cloneDeep(newItemModel);
    setItemStorage(_.cloneDeep(newModel));
  }

  async function uploadDataCheck() {
    const apiLocResult = await appContext.api.getLookupItems(SQLIndex.WareLocation, '', '');
    setItemStorage({ locResult: apiLocResult?.entities || [] });

    const apiItemResult = await appContext.api.getLookupItems(SQLIndex.WareRcvItems, '', itemStorage?.custType);
    setItemStorage({ itemResult: apiItemResult?.entities || [] });
  }

  function doClose(doRefresh: boolean = false) {
    removeItemStorage();
    params.onPopupClose();
    if (doRefresh === true) jobListContext.reloadData();
  }

  async function doSave() {
    if (itemStorage?.fileCount === 0) return;
    await uploadDataCheck();

    let sqlInfoList: SQLInfo[] = [];
    //A : ItemNo, B: UpcCode,C: Description,	D: PcsPerBox,	E: LOC
    itemStorage?.scanItem.forEach(function (value) {
      if (value.A.length === 0 || Number.isNaN(Number(value.D))) return;

      if (itemStorage?.itemResult.findIndex(v => v.itemNo === value.A) !== -1) return;

      if (value.E !== '' && itemStorage?.locResult.findIndex(v => v.location === value.E + '') === -1) return;

      if (value.B.length > 30 || value.C.length > 50) return;

      sqlInfoList.push(new SQLInfo({
        tableName: "T_WITEM",
        type: SQLType.Insert,
        fields: [
          new SQLField({ fieldName: "F_CENTER_NO", propertyName: "centerNo", value: itemStorage?.custType }),
          new SQLField({ fieldName: "F_ITEMNO", propertyName: "itemNo", value: value.A }),
          new SQLField({ fieldName: "F_ITEMDESCRIPTION", propertyName: "itemDescription", value: value.C }),
          new SQLField({ fieldName: "F_PCSPERBOX", propertyName: "pcsPerBox", value: value.D }),
          new SQLField({ fieldName: "F_DLOCATION", propertyName: "dLocation", value: value.E }),
          new SQLField({ fieldName: "F_UPCCODE", propertyName: "upcCode", value: value.B }),
          new SQLField({ fieldName: "U1ID", propertyName: "u1ID", value: userID }),
          new SQLField({ fieldName: "U1Date", propertyName: "u1Date", value: "GetDate()" }),
          new SQLField({ fieldName: "U2ID", propertyName: "u2ID", value: userID }),
          new SQLField({ fieldName: "U2Date", propertyName: "u2Date", value: "GetDate()" }),
        ]
      }));
    });

    const apiResult: ApiResult<InsertResultsWithData> = await appContext.api.saveUpload(JobNames.WHItem,
      sqlInfoList);

    if (!apiResult || !apiResult.success) {
      await showGlobalOkDialog(<p>Save failed</p>, false);
    }
    else {
      await showGlobalOkDialog(<p>The data has been saved</p>);
    }

    doClose(true);
  }

  return (
    <ItemUploadInitializedImpl onPopupClose={doClose} onSave={doSave}
      isPhysicalInven={params.isPhysicalInven} wItemEDI={itemStorage ?? new WItemEDI()} onChange={setItemStorage} />
  );
}

function ItemUploadInitializedImpl({
  onPopupClose,
  isPhysicalInven,
  wItemEDI,
  onChange,
  onSave,
}: ItemUploadLoadedParams) {
  const [showGlobalOkDialog] = useGlobalOkDialog();

  const handleUploadFile = async (e: any) => {
    if (e.target === null || e.target === undefined)
      return;

    if (e.target.files.length === 0) {
      if (wItemEDI.fileName !== null)
        return;
    }
    else if (e.target.files.length !== 1) {
      showGlobalOkDialog(<p>*파일은 하나만 선택하세요*</p>, false);
      return;
    }

    if (isPhysicalInven) {
      showGlobalOkDialog(<p>*옳지 않은 양식입니다.*</p>, false);
      return;
    }
    else {
      const data = await e.target.files[0].arrayBuffer();

      const excelData = readExcel(data);

      //onChange({ scanItem: excelData, fileCount: excelData.length , fileName : e.target.files[0].name, filePath : e.target.files[0].mozFullPath});
      onChange({ scanItem: excelData, fileCount: excelData.length, fileName: e.target.files[0].name });
    }
  };

  return (
    <div className='report-popup'>
      <div>
        <InlineInputControlRow label="Customer (WH)" mode="w100">
          <EdiWebCenterDropDown
            selectId='item-EDI' value={isPhysicalInven ? 'Scan Data (.txt)' : (wItemEDI.custType ?? '')}
            onChange={cust => onChange({
              custType: cust?.centerNo ?? '',
              //custName: cust?.centerNo ?? ''
            })}
            disabled={isPhysicalInven}
            isConfirmed={isPhysicalInven}
          />
        </InlineInputControlRow>

        {/* <InlineInputControlRow label="File Path" mode="w80">
          <TextBox disabled value={wItemEDI.filePath} />
        </InlineInputControlRow> */}

        <InlineInputControlRow label="File Name" mode="w100">
          <div style={{ display: 'flex' }}>
            <div style={{ width: '150px' }}>
              <TextBox disabled value={wItemEDI.fileName} />
            </div>
            <div>
              <GreenButtonInputExcel isText={isPhysicalInven}
                disabled={wItemEDI.custType === '' && !isPhysicalInven} handleFile={(e: React.ChangeEvent<HTMLInputElement>) => { handleUploadFile(e) }}>
                Browse
              </GreenButtonInputExcel>
            </div>
          </div>
        </InlineInputControlRow>
      </div>

      <InlineInputControlRow label="Count" mode="w100">
        <div style={{ display: 'flex' }}>
          <div style={{ width: '120px' }}>
            <Float value={wItemEDI.fileCount} decimals={0} disabled={true} />
          </div>
          {/* <div style={{ width: '120px', paddingLeft: '30px' }}>
            <CheckBox value={false} label="Clear All" />
          </div> */}
        </div>
      </InlineInputControlRow>
      
      <div className='report-footer'>
        <SecondaryButton
          size="regular"
          style={{ width: '90px' }}
          onClick={onSave}
        >
          SAVE
        </SecondaryButton>
        <SecondaryButton
          size="regular"
          style={{ width: '90px' }}
          onClick={onPopupClose}>
          CANCEL
        </SecondaryButton>
      </div>
    </div>
  );
}

const ItemUpload = ({
  onPopupClose,
  isPhysicalInven,
}: {
  onPopupClose: () => void
  isPhysicalInven: boolean,
}) => {
  return (
    <ItemUploadImpl onPopupClose={onPopupClose} key={`item-upload-details`} isPhysicalInven={isPhysicalInven} />
  );
};
export default ItemUpload;
